<template>
  <v-app>
    <the-top-bar
      @toggleDrawer="drawer = !drawer"
      :isOpen="drawer"
    ></the-top-bar>
    <v-navigation-drawer v-model="drawer" app clipped right class="d-md-none">
      <the-mobile-nav @close="drawer = false"></the-mobile-nav>
    </v-navigation-drawer>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <the-footer></the-footer>
  </v-app>
</template>

<script>
import TheFooter from '@/components/TheFooter'
import TheMobileNav from '@/components/TheMobileNav'
import TheTopBar from '@/components/TheTopBar'

export default {
  data() {
    return {
      drawer: false
    }
  },
  components: {
    TheFooter,
    TheMobileNav,
    TheTopBar
  },
  mounted() {
    this.$store.dispatch('graduates/load')
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'FavoritPro';
  src: url('assets/fonts/FavoritPro-Book.woff') format('woff');
}

@font-face {
  font-family: 'Langulaire';
  src: url('assets/fonts/Langulaire-Regular.woff') format('woff');
}

.v-application {
  font-family: FavoritPro;
}

.v-main {
  padding: 0 !important;
}

body {
  font-size: 25px;
  line-height: 1.2;
}

h1,
h2,
h3,
p {
  font-size: 1.5em;
  font-weight: 400;
  line-height: 1.2;
}

button:focus {
  outline: none;
}

@import '~vuetify/src/styles/styles.sass';

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  body {
    font-size: 18px;
  }

  h1,
  h2,
  h3,
  p {
    font-size: 1em;
  }
}
</style>
